import { PageHero } from "../components/PageHero";
import { usePageMeta } from "../hooks/usePageMeta";
import { CONTACT } from "../data/site";

export default function Privacy() {
  usePageMeta("Privacy Policy & Cookie Law | Nuova Giga Print", "Informativa privacy e cookie di Nuova Giga Print.");
  return (
    <>
      <PageHero eyebrow="Privacy" title="Privacy Policy & Cookie Law" img="/img/printer-roll.webp" alt="" />
      <section className="mx-auto max-w-3xl px-5 py-20 text-base leading-relaxed sm:px-8 lg:py-28" data-testid="privacy-content">
        <p className="rounded-[var(--ngp-radius)] border border-dashed border-[color:var(--ngp-teal-ink)] bg-white p-5 text-sm">
          [Placeholder] Inserire qui il testo ufficiale dell'informativa privacy e cookie fornito dal titolare del trattamento.
        </p>
        <h2 className="font-display mt-10 text-2xl font-semibold">Titolare del trattamento</h2>
        <p className="mt-3 text-[color:var(--ngp-muted)]">Nuova Gigaprint — P.iva {CONTACT.vat} — Via Giovanni Neper, 14 - 00166 Roma — info@gigaprint.it</p>
        <h2 className="font-display mt-10 text-2xl font-semibold">Gestione dei cookie</h2>
        <p className="mt-3 text-[color:var(--ngp-muted)]">Puoi modificare le tue preferenze in qualsiasi momento.</p>
        <button onClick={() => { localStorage.removeItem("ngp_cookie_consent"); window.location.reload(); }} data-testid="privacy-reset-cookies" className="mt-4 rounded-full bg-[color:var(--ngp-ink)] px-5 py-2.5 text-sm font-semibold text-white">Modifica preferenze cookie</button>
      </section>
    </>
  );
}
